export var OfferEnum = function (OfferEnum) {
  OfferEnum["EMPLOYEE"] = "EMP01";
  OfferEnum["EMPLOYEE_RATE_CODE"] = "EMPLOYEE";
  return OfferEnum;
}({});